import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import Login from './pages/auth/Login'
import SignUp from './pages/auth/SignUp'
import ForgotPassword from './pages/auth/ForgotPassword'
import Dashboard from './pages/Dashboard'
import Trusts from './pages/Trusts'
import NewTrust from './pages/NewTrust'
import TrustDetail from './pages/TrustDetail'
import NewAccount from './pages/NewAccount'
import NewBeneficiary from './pages/NewBeneficiary'
import Transactions from './pages/Transactions'
import NewTransaction from './pages/NewTransaction'
import TransactionDetail from './pages/TransactionDetail'
import Reports from './pages/Reports'
import Documents from './pages/Documents'
import Settings from './pages/Settings'

function PrivateRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <p className="text-gray-400">Loading...</p>
      </div>
    )
  }
  return user ? children : <Navigate to="/login" />
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/trusts" element={<PrivateRoute><Trusts /></PrivateRoute>} />
      <Route path="/trusts/new" element={<PrivateRoute><NewTrust /></PrivateRoute>} />
      <Route path="/trusts/:id" element={<PrivateRoute><TrustDetail /></PrivateRoute>} />
      <Route path="/trusts/:id/accounts/new" element={<PrivateRoute><NewAccount /></PrivateRoute>} />
      <Route path="/trusts/:id/beneficiaries/new" element={<PrivateRoute><NewBeneficiary /></PrivateRoute>} />
      <Route path="/transactions" element={<PrivateRoute><Transactions /></PrivateRoute>} />
      <Route path="/transactions/new" element={<PrivateRoute><NewTransaction /></PrivateRoute>} />
      <Route path="/transactions/:id" element={<PrivateRoute><TransactionDetail /></PrivateRoute>} />
      <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
      <Route path="/documents" element={<PrivateRoute><Documents /></PrivateRoute>} />
      <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  )
}